import {Autocomplete} from '../../1elements'
import {useEffect, useState} from 'react'
import ApiService from '../../../common/ApiCalls'

const searchStyles = {
    padding: 0,
    width: '40%'
}
const inputStyles = { padding: '5px 13px' }

const ClientSearch = ({selectedClient, setSelectedClient, validation, disabled, className, includeAllClients = false}) => {
    const [searchWord, setSearchWord] = useState('')
    const [options, setOptions] = useState([])

    const updateSearchWord = (e) => {
        setSearchWord(e.target.value)
    }

    useEffect(()=> {
        if(searchWord.length > 0){
            const keyword = {searchInput: searchWord}
            const searchAccounts = includeAllClients
                ? ApiService().searchAllAccountsByName
                : ApiService().searchAccountByName
            searchAccounts(keyword)
                .then((res)=> {
                    setOptions(res)
                })
                .catch((err)=> {
                    console.log('There was an error on searchAccountByName: ', err)
                })
        }else{
            setOptions([])
        }
    }, [includeAllClients, searchWord])

    return (
        <Autocomplete className={className} inputRootSx={searchStyles} inputStyle={inputStyles} value={selectedClient} onChangeTextField={updateSearchWord}
                      options={options} onChangeAutocomplete={setSelectedClient} validation={validation} showError={validation}
                      optionLabel={'name'} disabled={disabled} />
    )
}

export default ClientSearch
